import { render } from "./Groups.vue?vue&type=template&id=1e124a8e"
import script from "./Groups.vue?vue&type=script&setup=true&lang=js"
export * from "./Groups.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Event/Groups.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e124a8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e124a8e', __exports__)) {
    api.reload('1e124a8e', __exports__)
  }
  
  module.hot.accept("./Groups.vue?vue&type=template&id=1e124a8e", () => {
    api.rerender('1e124a8e', render)
  })

}


export default __exports__